import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Accessible breadcrumb with JSON-LD BreadcrumbList structured data.
 * Props: items = [{ label, href? }]  (the last item is the current page, no href needed)
 */
export default function Breadcrumbs({ items = [] }) {
  if (!items || items.length === 0) return null;

  // JSON-LD schema
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.href ? { item: window.location.origin + it.href } : {}),
    })),
  };

  return (
    <>
      <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
        <ol className="flex items-center flex-wrap gap-1 text-xs text-slate-500">
          {items.map((it, i) => {
            const isLast = i === items.length - 1;
            return (
              <li key={i} className="flex items-center gap-1">
                {i > 0 && <ChevronRight size={12} className="text-slate-300" />}
                {it.href && !isLast ? (
                  <Link to={it.href} className="hover:text-primary transition-colors" data-testid={`crumb-${i}`}>
                    {it.label}
                  </Link>
                ) : (
                  <span className={isLast ? "text-slate-900 font-medium" : ""} data-testid={`crumb-${i}`}>
                    {it.label}
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
    </>
  );
}
